import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownProductPenalties', request)
}

async function put(request) {
    return await putMethod('/api/ownProductPenalties', request)
}

async function post(body) {
    return await postMethod('/api/ownProductPenalties', body)
}

export {get, put, post}
